import { Divider, Tab, Tabs } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AssignmentReturnIcon from '@material-ui/icons/AssignmentReturn';
import PersonAddDisabledIcon from '@material-ui/icons/PersonAddDisabled';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import { Fragment, useEffect, useState } from 'react';
import { Button, Confirm, Datagrid, DatagridProps, DateField, Edit, Identifier, ListButton, ListContextProvider, ListProps, maxValue, NumberInput, ReferenceField, ReferenceInput, required, SelectArrayInput, SelectInput, SimpleForm, TextField, TextInput, Toolbar, useAuthProvider, useDataProvider, useListContext, useNotify, useRecordContext, useRefresh, useTranslate, useUnselectAll } from "react-admin";
import { useForm } from 'react-final-form';
import { getObjectValue, AvatarField, CustomTitle, Field, Legend, Loader, ObjectField, Row, Spacing, TranslateField, Clear, ExternalLink } from "../common/components";
import { taskStatus } from '../common/components/utils/choice';
import { count } from '../services/common/common';
import { taskAssign, taskBulkAssignMyself, taskBulkForceBack, taskBulkForceGo, taskBulkUnassign, taskCancel, taskComplete, taskReject, taskUnassign, useHandleChange } from '../services/task/actions';
import { translateTime } from '../services/task/list';
import { List } from "@react-admin/ra-rbac";
import { filter, filterObject, filterValue } from '../common/components/utils/fn';
import Uploader from '../common/components/uppy/Uploader';
import { ProductionUnitList } from './ProductionUnit';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { startLot } from '../services/lot/actions';

export const TaskIcon = AssignmentIcon;

const EstimateTimeField = ({ source }) => {
    const [value, setValue] = useState(null);
    const translate = useTranslate();
    const record = useRecordContext();
    useEffect(() => {
        if (record) {
            if (record[source]) {
                setValue(translateTime(translate, record[source]));
            } else {
                setValue(null);
            }
        }
    }, [record, source, translate]);
    return <span>{value}</span>;
};

const InputTimeField = (props) => {
    const [value, setValue] = useState("");
    const translate = useTranslate();
    const record = useRecordContext();
    useEffect(() => {
        if (record && (record.taskStatus === "rejected" || record.taskStatus === "completed")) {
            setValue(translateTime(translate, {
                hour: record.hour,
                minute: record.minute
            }));
        } else {
            setValue("");
        }
    }, [record, translate]);
    return <span>{value}</span>;
};

interface TaskTrackingListProps extends ListProps {
    productionUnitId: Identifier;
}

export const TaskTrackingList = (propsReceive: TaskTrackingListProps) => {
    const { productionUnitId, ...propsOthers } = propsReceive;
    const props = {
        ...propsOthers,
        resource: "task",
        basePath: "/task",
        title: " ",
        bulkActionButtons: false,
        filterDefaultValues: { ...propsOthers.filterDefaultValues, productionUnitId, taskStatus: ['available', 'assigned'] }
    };
    return <List {...props} filters={[
        <SelectArrayInput source="taskStatus" choices={taskStatus} alwaysOn />
    ]}>
        <Datagrid>
            <ObjectField source="stage.name" />
            <DateField source="availableDate" />
            <ReferenceField source="assignTo" reference="user">
                <AvatarField source="fullname" />
            </ReferenceField>
            <DateField source="assignedDate" />
            <DateField source="endDate" />
            <EstimateTimeField source="estimateTime" />
            <InputTimeField source="inputTime" />
            <TranslateField source="taskStatus" />*/
        </Datagrid>
    </List>
};

const TaskDatagrid = ({ type, ...props }) => <Datagrid {...props} rowClick="edit">
    <ObjectField label="resources.task.fields.project" source="production_unit.lot.project.name" />
    <ObjectField source="stage.name" />
    <TextField source="production_unit.lot.name" />
    <ObjectField type="date" source="production_unit.lot.endDate" />
    <ReferenceField source="productionUnitId" reference="production_unit" link={false}>
        <TextField source="name" />
    </ReferenceField>
    <ObjectField label="resources.task.fields.team" source="stage_info.team.name" />
    {type === "available" && <DateField source="availableDate" />}
    {type === "assigned" && <DateField source="assignedDate" />}
    {type === "ended" && <DateField source="endDate" />}
    <EstimateTimeField source="estimateTime" />
    {type === "ended" && <InputTimeField source="inputTime" />}
    {type !== "available" && <ReferenceField source="assignTo" reference="user">
        <AvatarField source="fullname" />
    </ReferenceField>}
    {type === "ended" && <TranslateField source="taskStatus" />}
</Datagrid>;


interface TabbedDatagridProps extends DatagridProps {
    securityFilters;
}

const TabbedDatagrid = ({ securityFilters, ...props }: TabbedDatagridProps) => {
    const [totalAvailable, setTotalAvailable] = useState(0);
    const [totalAssigned, setTotalAssigned] = useState(0);
    const [totalEnded, setTotalEnded] = useState(0);
    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const listContext = useListContext();
    const { filterValues, setFilters, displayedFilters } = listContext;
    const handleChange = useHandleChange(displayedFilters, filterValues, setFilters);
    useEffect(() => {
        count(dataProvider, "task", { ...filterValues, ...securityFilters, taskStatus: "available" }).then((total) => {
            setTotalAvailable(total);
        });
        count(dataProvider, "task", { ...filterValues, ...securityFilters, taskStatus: "assigned" }).then((total) => {
            setTotalAssigned(total);
        });
        count(dataProvider, "task", { ...filterValues, ...securityFilters, taskStatus: ["completed", "rejected", "cancelled"] }).then((total) => {
            setTotalEnded(total);
        });
    }, [dataProvider, filterValues, securityFilters]);
    return (
        <Fragment>
            <Tabs variant="fullWidth" value={typeof filterValues.taskStatus === "object" ? "ended" : filterValues.taskStatus} onChange={handleChange}>
                <Tab label={`${translate("resources.taskStatus.available")} (${totalAvailable})`} value="available" />
                <Tab label={`${translate("resources.taskStatus.assigned")}  (${totalAssigned})`} value="assigned" />
                <Tab label={`${translate("resources.taskStatus.completed")}  (${totalEnded})`} value="ended" />
            </Tabs>
            <Divider />
            <ListContextProvider value={{ ...listContext }}>
                {filterValues.taskStatus === 'available' && (
                    <TaskDatagrid {...props} type="available" />
                )}
                {filterValues.taskStatus === 'assigned' && (
                    <TaskDatagrid {...props} type="assigned" />
                )}
                {filterValues.taskStatus !== 'assigned' && filterValues.taskStatus !== 'available' && (
                    <TaskDatagrid {...props} type="ended" />
                )}
            </ListContextProvider>
        </Fragment>
    );
};


const BulkToolbar = (props) => {
    const [action, setAction] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const { filterValues, selectedIds } = useListContext();
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const unselectAll = useUnselectAll();
    const authProvider = useAuthProvider();
    const isAvailable = filterValues && filterValues.taskStatus === "available";
    const isAssigned = filterValues && filterValues.taskStatus === "assigned";
    const isEnded = !isAvailable && !isAssigned;
    const handleConfirm = async () => {
        setLoading(true);
        try {
            if (action === "forceGo") {
                await taskBulkForceGo(dataProvider, selectedIds);
            } else if (action === "forceBack") {
                await taskBulkForceBack(dataProvider, selectedIds);
            } else if (action === "bulkUnassign") {
                await taskBulkUnassign(dataProvider, selectedIds);
            } else if (action === "bulkAssignMyself") {
                await taskBulkAssignMyself(dataProvider, selectedIds, authProvider.getId());
            }
            setLoading(false);
            unselectAll("task");
            refresh();
            notify(`resources.task.success.${action}`, { type: "info", messageArgs: { smart_count: selectedIds.length } });
        } catch (err) {
            setLoading(false);
            refresh();
            notify(err.message, { type: "error", messageArgs: { smart_count: selectedIds.length } })
        }
    };
    return <Fragment>
        <Confirm
            isOpen={action !== null}
            loading={isLoading}
            title={action ? `resources.task.actionTitle.${action}` : ""}
            content={action ? `resources.task.actionContent.${action}` : ""}
            onConfirm={handleConfirm}
            onClose={() => {
                setAction(null);
            }}
        />
        {isAvailable && <Button onClick={() => setAction("bulkAssignMyself")} variant="contained" label="resources.bulkAssignMyself"><AssignmentIcon /></Button>}
        {isAssigned && <Button onClick={() => setAction("bulkUnassign")} variant="contained" label="resources.unassign"><PersonAddDisabledIcon /></Button>}
        {!isEnded && <Button onClick={() => setAction("forceGo")} variant="contained" label="resources.forceGo" className="activate"><AssignmentTurnedInIcon /></Button>}
        {isEnded && <Button onClick={() => setAction("forceBack")} variant="contained" label="resources.forceBack" className="deactivate"><AssignmentReturnIcon /></Button>}
    </Fragment>;
};

const ProjectFilter = (props) => {
    const { securityProject } = props;
    const { filterValues, setFilters, displayedFilters } = useListContext();
    const projectFilterId = filterValues?.["@production_unit"]?.lot?.project?.id?._eq;
    return <>
        <ReferenceInput className="hidehelper" allowEmpty label="resources.task.fields.project" source="@production_unit.lot.project.id._eq" reference="project" filter={{ ...securityProject, status: "enabled" }} onChange={(e) => { let f = { ...filterValues, "@production_unit": filterObject("lot.project.id._eq", e.target.value) }; setFilters(f, displayedFilters) }}>
            <SelectInput source="name" />
        </ReferenceInput>
        {projectFilterId && <ReferenceInput className="hidehelper spacebefore" label="resources.task.fields.lot" source="@production_unit.lot.id._eq" reference="lot" filter={{ project: filter("id", projectFilterId) }}>
            <SelectInput source="name" />
        </ReferenceInput>
        }
    </>;
};

export const TaskList = (props: ListProps) => {
    const authProvider = useAuthProvider();
    const [security, setSecurity] = useState(null);
    const [securityProject, setSecurityProject] = useState(null);
    const [securityTeam, setSecurityTeam] = useState(null);
    const [securityUser, setSecurityUser] = useState(null);
    useEffect(() => {
        const id = authProvider.getId();
        const role = authProvider.getRole();
        if (role === "projectManager") {
            setSecurity({
                _or: filterValue([
                    filterObject("assignTo._eq", id),
                    filterObject("production_unit.lot.project.ownerId._eq", id),
                    filterObject("production_unit.lot.project.project_delegates.userId._eq", id)
                ])
            });
            setSecurityProject({
                _or: filterValue([
                    filterObject("ownerId._eq", id),
                    filterObject("project_delegates.userId._eq", id)
                ])
            });
            setSecurityTeam({
                _or: filterValue([
                    filterObject("stage_info.project.ownerId._eq", id),
                    filterObject("stage_info.project.project_delegates.userId._eq", id),
                    filterObject("tasks.stage_info.project.ownerId._eq", id),
                    filterObject("tasks.stage_info.project.project_delegates.userId._eq", id)
                ])
            })
            setSecurityUser({
                _or: filterValue([
                    filterObject("id._eq", id),
                    filterObject("members.team.stage_info.project.ownerId._eq", id),
                    filterObject("members.team.stage_info.project.project_delegates.userId._eq", id),
                    filterObject("members.team.tasks.stage_info.project.ownerId._eq", id),
                    filterObject("members.team.tasks.stage_info.project.project_delegates.userId._eq", id)
                ])
            });
        } else if (role === "teamManager") {
            setSecurity({
                _or: filterValue([
                    filterObject("assignTo._eq", id),
                    filterObject("stage_info.team.managerId._eq", id),
                    filterObject("team.managerId._eq", id)
                ])
            });
            setSecurityProject({
                _or: filterValue([
                    { stage_info: filterObject("team.managerId._eq", id) },
                    { lot: filterObject("production_unit.tasks.team.managerId._eq", id) }
                ])
            });
            setSecurityTeam({ managerId: id })
            setSecurityUser({
                _or: filterValue([
                    filterObject("id._eq", id),
                    filterObject("members.team.managerId._eq", id)
                ])
            });
        } else if (role === "productor") {
            setSecurity({
                _or: filterValue([
                    { assignTo: { _eq: id } },
                    {
                        stage_info: filterObject("team.members.userId._eq", id),
                        _or: [
                            { assignTo: { _is_null: true } },
                            { assignTo: { _eq: id } }
                        ]
                    },
                    {
                        team: filterObject("members.userId._eq", id),
                        _or: [
                            { assignTo: { _is_null: true } },
                            { assignTo: { _eq: id } }
                        ]
                    }
                ])
            });
            setSecurityProject({
                _or: filterValue([
                    { stage_info: filterObject("team.members.userId._eq", id) },
                    { lot: filterObject("production_unit.tasks.team.members.userId._eq", id) }
                ])
            });
            setSecurityTeam({ members: filter("userId", id) })
            setSecurityUser({ id });
        }
    }, [authProvider]);
    if (!authProvider) <Loader />;
    return <List
        {...props}
        filter={security}
        filterDefaultValues={{ taskStatus: 'available' }}
        sort={{ field: 'production_unit.lot.endDate', order: 'ASC' }}
        bulkActionButtons={<BulkToolbar />}
        filters={[
            <ProjectFilter source="project" securityProject={securityProject} alwaysOn />,
            <ReferenceInput label="resources.task.fields.team" source="@stage_info.team.id._eq" reference="team" filter={securityTeam} alwaysOn>
                <SelectInput source="name" />
            </ReferenceInput>,
            <ReferenceInput source="assignTo" reference="user" filter={securityUser}>
                <SelectInput optionText="fullname" />
            </ReferenceInput>
        ]}
    >
        <TabbedDatagrid securityFilters={security} />
    </List >
};

const TaskToolbar = ({ save, ...props }) => {
    const [action, setAction] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const form = useForm();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();
    const translate = useTranslate();
    const record = (props && props.record) || {};
    const isSubproject = record.subprojectLotId;
    const isAvailable = record.taskStatus === "available" && !isSubproject;
    const isStartable = record.taskStatus === "available" && isSubproject;
    const isAssigned = record.taskStatus === "assigned";
    const isCancel = record.taskStatus === "cancelled";
    const hasReject = getObjectValue(record, "stage.hasReject");
    const canBeCancel = !isCancel && getObjectValue(record, "stage.isStarting") === false;
    const handleConfirm = async () => {
        setLoading(true);
        if (action === "cancel") {
            await taskCancel(form, dataProvider);
        }
        setLoading(false);
        refresh();
        notify(`resources.task.success.${action}`, { type: "info", messageArgs: { smart_count: 1 } });
    };
    return <Toolbar {...props}>
        <Confirm
            isOpen={action !== null}
            loading={isLoading}
            title={action ? `resources.task.actionTitle.${action}` : ""}
            content={action ? `resources.task.actionContent.${action}` : ""}
            onConfirm={handleConfirm}
            onClose={() => {
                setAction(null);
            }}
        />
        {isStartable && <Button onClick={startLot(dataProvider, refresh, translate, notify, record.subprojectLotId)} label="resources.start" className="activate" variant="contained"><PlayArrowIcon /></Button>}
        {isAssigned && !isSubproject && <Button onClick={taskComplete(form, notify, dataProvider)} variant="contained" label="resources.valid" className="activate"><AssignmentTurnedInIcon /></Button>}
        {(isAssigned || isSubproject) && hasReject && <Button onClick={taskReject(form, notify, dataProvider)} variant="contained" label="resources.reject" className="deactivate"><ThumbDownIcon /></Button>}
        {isAvailable && <Button onClick={taskAssign(form, notify, dataProvider, translate)} variant="contained" label="resources.assign"><AssignmentIndIcon /></Button>}
        {isAssigned && !isSubproject && <Button onClick={taskUnassign(form, notify, dataProvider)} variant="contained" label="resources.unassign"><PersonAddDisabledIcon /></Button>}
        <Spacing />
        <ListButton variant="outlined" />
        {canBeCancel && <Button onClick={() => setAction("cancel")} variant="outlined" color="secondary" label="resources.cancel"><AssignmentReturnIcon /></Button>}
    </Toolbar>
};

const validateTask = (values) => {
    const errors = {};
    if (values.taskStatus !== "available" && values.hour === 0 && values.minute === 0) {
        errors["hour"] = "resources.validate.unitTime";
        errors["minute"] = "resources.validate.unitTime";
    }
    return errors;
};

const TaskForm = props => {
    const authProvider = useAuthProvider();
    const record = props.record;
    const [showQT, setShowQt] = useState(record.quantityTask !== undefined);
    const isAvailable = record.taskStatus === "available";
    const isAssigned = record.taskStatus === "assigned";
    const disabledFields = !isAvailable && !isAssigned;
    const [estimateValue, setEstimateValue] = useState("");
    const translate = useTranslate();
    const teamId = getObjectValue(record, "team.id") || getObjectValue(record, "stage_info.team.id");
    const filterProductor = authProvider.getRole() === "productor" ? { id: authProvider.getId() } : { members: filter("team.id", teamId) }
    useEffect(() => {
        setEstimateValue(translateTime(translate, record.estimateTime));
    }, [record.estimateTime, translate]);
    const subprojectLotId = record.subprojectLotId;
    const hasExternalProductionFile = record.production_unit?.lot?.project?.hasExternalProductionFile || false;
    return <SimpleForm {...props} initialValues={{ previousProductionFileExternal: null, productionFileExternal: null }} toolbar={<TaskToolbar {...props} />} validate={validateTask}>
        <Legend />
        <ObjectField formClassName="fl25" label="resources.task.fields.project" source="production_unit.lot.project.name" />
        <ObjectField formClassName="fl25" source="stage.name" />
        <ObjectField formClassName="fl25" source="production_unit.lot.name" />
        <ObjectField type="date" source="production_unit.lot.endDate" />
        <ObjectField formClassName="fl25" source="production_unit.name" label={<ObjectField source="production_unit.lot.project.unitProd" />} />
        <Field formClassName={`fl25${disabledFields ? "" : " editable"}`} onClick={() => !disabledFields && setShowQt(!showQT)} source="quantity" value={`${record.quantity || getObjectValue(record, "production_unit.quantity")} ${getObjectValue(record, "production_unit.lot.project.unitMeasure")}`} />
        <Field formClassName="fl25" label="resources.task.fields.estimateTime" value={estimateValue} />
        <TranslateField source="taskStatus" />
        {showQT && <NumberInput disabled={disabledFields} source="quantityTask" step={1} />}
        {record.comment && <TextField fullWidth source="comment" component="pre" />}
        <TextInput source="commentTask" disabled={disabledFields} multiline />
        {!subprojectLotId && <ReferenceInput disabled={!isAvailable} source="assignTo" reference="user" validate={[required()]} filter={filterProductor}>
            <SelectInput optionText="fullname" />
        </ReferenceInput>}
        {!isAvailable && <Row>
            <NumberInput label="resources.unitTime.hour" disabled={disabledFields} source="hour" defaultValue={0} step={1} />
            <NumberInput label="resources.unitTime.minute" disabled={disabledFields} source="minute" defaultValue={0} step={5} max={59} validate={maxValue(59)} />
        </Row>}
        {!isAvailable && record.team_next.length > 0 && <SelectInput disabled={disabledFields} source="nextTeamAssignTo" choices={record.team_next} />}
        {!isAvailable && record.team_reject.length > 0 && <SelectInput disabled={disabledFields} source="rejectTeamAssignTo" choices={record.team_reject} />}
        {hasExternalProductionFile && <ExternalLink disabled formClassName='fl50' source="previousProductionFileExternal" />}
        {!hasExternalProductionFile && <Uploader disabled formClassName='fl50' source="previousProductionFile" />}
        <Uploader disabled formClassName='fl50' source="previousShuttleFile" />
        {hasExternalProductionFile && !isAvailable && <ExternalLink disabled={disabledFields} formClassName='cb fl50' source="productionFileExternal" />}
        {!hasExternalProductionFile && !isAvailable && <Uploader disabled={disabledFields} formClassName='fl50' source="shuttleFile" allowedFileTypes={['.doc', '.docx', '.xls', '.xlsx', '.odt', '.ods', '.txt', '.csv', '.zip']} />}
        {!isAvailable && <Uploader disabled={disabledFields} formClassName='fl50' source="shuttleFile" allowedFileTypes={['.doc', '.docx', '.xls', '.xlsx', '.odt', '.ods', '.txt', '.csv', '.zip']} />}
        <Clear />
        {subprojectLotId &&
            <>
                <Legend label="resources.task.fields.sub" variant="h4" />
                <Row><ProductionUnitList lotId={subprojectLotId} simple hasMap={false} /></Row>
            </>}
    </SimpleForm>
};

export const TaskEdit = props => <Edit {...props} title={<CustomTitle title="task" value="id" />} mutationMode="pessimistic">
    <TaskForm />
</Edit>
